import { api } from "@/lib/api";

// Shared active-timer store: one running timer per tech, surfaced globally + on the ticket page.
let current = null;
let started = false;
const listeners = new Set();

function emit() { listeners.forEach((fn) => fn(current)); }

export async function refreshTimer() {
  try {
    const r = await api.get("/tickets/timer/active");
    current = r.data.active;
    emit();
  } catch { /* keep last known value */ }
  return current;
}

export function subscribeTimer(fn) {
  listeners.add(fn);
  fn(current);
  if (!started) { started = true; refreshTimer(); }
  return () => listeners.delete(fn);
}

export function getTimer() { return current; }
